import { createSvgIcon } from '@mui/material/utils';

export const LikeIcon = createSvgIcon(
    <>
        <path d='M8.297 5C5.437 5 3 7.137 3 9.91c0 1.914.898 3.527 2.086 4.863 1.187 1.329 2.715 2.446 4.098 3.383l2.382 1.61c.262.18.606.18.868 0l2.382-1.61c1.383-.937 2.91-2.054 4.098-3.383C20.102 13.438 21 11.824 21 9.91 21 7.137 18.562 5 15.703 5 14.227 5 12.93 5.691 12 6.586 11.07 5.69 9.773 5 8.297 5zm0 0' />
    </>,
    'LikeIcon'
);
